import React from 'react';
import { FcInvite, FcSalesPerformance, FcSimCardChip } from 'react-icons/fc';
import Card from './Card';

function GiftCardCard(props) {
    return (
        <Card clickCardHandler={props.clickCardHandler} title="ثبت کارت هدیه" icon={FcSimCardChip}>
        </Card>
    );
}
export default GiftCardCard;